import { Flex } from '@revenuemarket/cds';

import TableCell from './TableCell';
import { TreeData, TreeNodeId } from './utils';

// 트리 렌더링 함수
export const renderTree = <T extends Record<string, unknown>>(
  node: TreeData<T>,
  focusedId?: TreeNodeId,
  setFocusedId?: (id: TreeNodeId) => void,
  onClick?: (nodeId: TreeNodeId) => void,
  foldable?: boolean,
  onFoldToggle?: (nodeId: TreeNodeId) => void,
  foldedNodeIds?: TreeNodeId[],
  filterCondition?: (node: TreeData<T>) => boolean,
  cellRenderer?: (node: TreeData<T>) => React.ReactNode,
  activatedId?: TreeNodeId,
) => {
  const nodeId = node.key.toString();

  return filterCondition?.(node) ? (
    <Flex
      key={nodeId}
      style={{
        width: 'fit-content',
        cursor: 'pointer',
      }}
      onKeyDown={(e) => {
        if (!focusedId) return;
        if (e.key === 'Enter') {
          e.stopPropagation();
          onClick?.(focusedId);
        }
      }}
    >
      <TableCell
        node={node}
        isFocused={nodeId === focusedId}
        onClick={(nodeId) => {
          onClick && onClick(nodeId);
        }}
        foldable={foldable}
        onFoldToggle={onFoldToggle}
        cellRenderer={cellRenderer}
        isActivated={activatedId === nodeId}
      />
      <Flex direction="column">
        {foldedNodeIds?.includes(nodeId)
          ? null
          : node.children.map((child: TreeData<T>) =>
              renderTree(
                child,
                focusedId,
                setFocusedId,
                onClick,
                foldable,
                onFoldToggle,
                foldedNodeIds,
                filterCondition,
                cellRenderer,
                activatedId,
              ),
            )}
      </Flex>
    </Flex>
  ) : null;
};

export const getTreeMaxDepth = <T extends Record<string, unknown>>(
  treeData: TreeData<T>[],
  foldedNodeIds: TreeNodeId[] = [],
) => {
  // fold된 노드는 depth 계산에서 제외

  let maxDepth = 0;
  function traverse(node: TreeData<T>, depth: number) {
    if (node?.status === 'new') return;
    if (depth > maxDepth) {
      maxDepth = depth;
    }

    if (node.children && node.children.length > 0) {
      if (foldedNodeIds.includes(node.key)) return;
      node.children.forEach((child: TreeData<T>) => traverse(child, depth + 1));
    }
  }

  treeData.forEach((node: TreeData<T>) => traverse(node, 1));
  return maxDepth;
};
